export const CART_ADD_ITEM = 'CART_ADD_ITEM'
export const CART_REMOVE_ITEM = 'CART_REMOVE_ITEM'
export const CART_REMOVE_ALL_ITEMS = 'CART_REMOVE_ALL_ITEMS'
export const CART_SAVE_SHIPPING_ADDRESS = 'CART_SAVE_SHIPPING_ADDRESS'
export const CART_SAVE_PAYMENT_MEHOD = 'CART_SAVE_PAYMENT_MEHOD'
export const CART_RESET = 'CART_RESET'
